/* eslint-disable arrow-parens */
import {
  select, all, put, takeLatest,
} from 'redux-saga/effects';
import API_ENDPOINTS from '../../../config/API-endpoints';
import { openRoutes, protectedRoutes } from '../../../routes';
import { getCookie } from '../../../utils';
import { fetcherAction } from '../fetcher/creator';
import { spinnerActions } from '../spinner/actions';
import { sessionActions, sessionConstants } from './creator';
import { getUserAuthToken } from './selector';
import history from '../../history';

import toaster from '../../../components/atoms/toaster';

const userAPI = {
  login: payload => ({
    tokenize: false,
    fetcherParams: {
      method: 'POST',
      url: API_ENDPOINTS.login,
      data: payload,
    },
    headers: { 'Content-Type': 'application/json' },
  }),
};

// eslint-disable-next-line consistent-return
function* handleSessionInit({ payload }) {
  const { isFirstRendering = false } = payload;
  let authToken = yield select(getUserAuthToken);
  if (!authToken) {
    authToken = getCookie('authToken');
  }
  if (isFirstRendering && !authToken) {
    return yield put(sessionActions.userLogout());
  }
}

function* handleLogin({ payload }) {
  yield put(spinnerActions.showSpinner({ message: 'Logging in, please wait' }));
  return yield put(
    fetcherAction({
      ...userAPI.login(payload),
      label: sessionConstants.USER_LOGIN,
    }),
  );
}

function* loginOnSuccess({ response: data }) {
  yield put(sessionActions.setSessionData({
    user: data.user,
    isAuthorized: true,
    authToken: `JWT ${data.token}`,
  }));
  document.cookie = `authToken=JWT ${data.token}; path=/`;
  yield put(spinnerActions.hideSpinner());
  return yield history.replace({ pathname: protectedRoutes.activeJobs });
}

function* loginOnFailure({ error = {} }) {
  // eslint-disable-next-line no-console
  console.error(error);
  yield put(spinnerActions.hideSpinner());
  toaster({
    type: 'error',
    msg: 'Invalid Email or Password',
    unique: true,
  });
  return yield put(sessionActions.userLogout());
}

function* logout() {
  localStorage.clear();
  document.cookie = `authToken=; expires=${new Date()}; path=/`;
  return yield history.push(openRoutes.root);
}

export default function* sessionSagas() {
  yield all([
    takeLatest(sessionConstants.USER_LOGIN.TRIGGER, handleLogin),
    takeLatest(sessionConstants.USER_LOGIN.SUCCESS, loginOnSuccess),
    takeLatest(sessionConstants.USER_LOGIN.FAILURE, loginOnFailure),
    takeLatest(sessionConstants.USER_LOGOUT, logout),
    // to use below pattern, 'connected-react-router' is required in dependencies.
    takeLatest('@@router/LOCATION_CHANGE', handleSessionInit),
  ]);
}


